$(function ($) {
    var floatingMenu = $('#floating-menu');
    floatingMenu.hide();

    $(window).scroll(function () {
        if ($(this).scrollTop() > 100) {
            floatingMenu.fadeIn();
        } else {
            floatingMenu.fadeOut();
        }
    });

    if ($(window).scrollTop() > 100 && !floatingMenu.is(':visible')) {
        floatingMenu.fadeIn();
    }

    floatingMenu.find('p').click(function () {
        var top = 0;
        var id = $(this).attr('id');
        if (id === 'to-cart') {
            top = $('#pi_cart').offset().top;
        }
        $('body,html').animate({
            scrollTop: top
        }, 500);
        return false;
    });
});

function addOnload(func) {
    try {
        window.addEventListener("load", func, false);
    } catch (e) {
        window.attachEvent("onload", func);
    }
}

function loadBtnToCart() {
    addOnload(function () {
        var btnToCart = document.getElementById('to-cart');
        if (btnToCart !== null) {
            btnToCart.style.display = '';
        }
    });
}